import { render, staticRenderFns } from "./IMControl.vue?vue&type=template&id=e806939e&scoped=true"
import script from "./IMControl.vue?vue&type=script&lang=js"
export * from "./IMControl.vue?vue&type=script&lang=js"
import style0 from "./IMControl.vue?vue&type=style&index=0&id=e806939e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806939e",
  null
  
)

export default component.exports